<script>
import resources from './resources'

export default {
  name: 'gadget-staff',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          identification
          select-dates
          statistics-agendas
          next-patient
          active-agenda
          summary-agenda
          agendas-statistics
          summary-billing
          abstract-speciality
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/index.vue